import React from 'react';

const PrimaryTableContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-col min-w-0 p-0 rounded-lg h-[50rem] w-full overflow-hidden border border-neutral-300">
      {children}
    </div>
  );
};

export default PrimaryTableContainer;
